import { useCmsData, useCmsDataLoader } from '../../../containers/CmsData';
import {
  CmsDataPage,
  Translate,
  MarketDataCmsData,
  TranslateHtml,
} from '../../../containers/CmsData/store/cmsData.model';

export function useMarketDataCmsData() {
  const cmsPageName = CmsDataPage.MarketData;
  const cmsDataLoading = useCmsDataLoader(cmsPageName);
  const { cmsLabel, cmsLabelHtml } = useCmsData();
  const getLabel: Translate<MarketDataCmsData> = (key: string, ...params) =>
    cmsLabel(`${cmsPageName}.${key}`, ...params);
  const getLabelHtml: TranslateHtml<MarketDataCmsData> = (key: string, ...params) =>
    cmsLabelHtml(`${cmsPageName}.${key}`, ...params);
  return { _t: getLabel, _tHtml: getLabelHtml, cmsDataLoading };
}
